import Interaction from 'ol/interaction/Interaction';

export class InteractionGroup extends Interaction {

  constructor (...interactions) {
    super({
      handleEvent: event => this.doHandleEvent(event)
    });
    this._interactions = interactions;
    this.setActive(false);
  }

  setActive (active) {
    if (active !== this.getActive()) {
      this._setAllInteractionsActive(active); // activate all interactions by default
    }
  }

  /**
   * Finds the passed interaction to active and all others to inactive
   *
   * @protected
   * @param activeInteraction - the interaction to set active
   */
  setSingleInteractionActive (activeInteraction) {
    super.setActive(true);
    this._getInteractions().forEach(interaction => interaction.setActive(interaction === activeInteraction));
  }

  _setAllInteractionsActive (active) {
    super.setActive(active);
    this._getInteractions().forEach(interaction => interaction.setActive(active));
  }

  setMap (map) {
    super.setMap(map);
    this._getInteractions().forEach(interaction => interaction.setMap(map));
  }

  getInteractionByClass (className) {
    return this._getInteractions().find(interaction => interaction instanceof className);
  }

  /**
   * Our own handling for the event which overrides the base one
   *
   * @protected
   * @param event - the event
   * @return whether the event was handled or not
   */
  doHandleEvent (event) {
    return !this._getInteractions().reduceRight((stop, interaction) => stop || !interaction.handleEvent(event), false);
  }

  _getInteractions () {
    return this._interactions || [];
  }

}
